import { useState } from 'react';

import PropTypes from 'prop-types';
import { BsClipboardPlus, BsListUl, BsTags } from 'react-icons/bs';

import AddToContactListModal from '#contactListFeature/components/AddToContactListModal/AddToContactListModal';
import ActionScopeButton from '#globalComponents/Table/actions/ActionScopeButton';
import { CONTACT_SELECTION_HINT } from '#lib/constants/entityLabels';

import BulkAddActivityModal from '../../pipeline/ListView/BulkAddActivityModal';
import BulkAssignTagsModal from '../BulkAssignTagsModal/BulkAssignTagsModal';

/**
 * Buttons for the company table's actions slot. They run on the company selection, or on every
 * company matching the filters. While contacts inside expanded rows are selected the actions are
 * disabled, since the selection then means contacts, not companies.
 */
const CompanyScopeActions = ({ companySelection, contactSelectionCount, allTags }) => {
	const [openModal, setOpenModal] = useState(null);
	const close = () => setOpenModal(null);

	const { actionCount, actionTarget: targetLabel, toActionScope, clear } = companySelection;
	const hasContactSelection = contactSelectionCount > 0;
	const disabled = hasContactSelection || actionCount === 0;
	const title = hasContactSelection ? CONTACT_SELECTION_HINT : undefined;

	return (
		<>
			<ActionScopeButton
				icon={<BsListUl />}
				disabled={disabled}
				title={title}
				onClick={() => setOpenModal('contactList')}
			>
				Zu Kontaktliste
			</ActionScopeButton>
			<ActionScopeButton icon={<BsTags />} disabled={disabled} title={title} onClick={() => setOpenModal('tags')}>
				Tags zuweisen
			</ActionScopeButton>
			<ActionScopeButton
				icon={<BsClipboardPlus />}
				disabled={disabled}
				title={title}
				onClick={() => setOpenModal('activity')}
			>
				Aktivität anlegen
			</ActionScopeButton>

			{openModal === 'contactList' && (
				<AddToContactListModal
					isOpen
					onClose={close}
					tableScope={{ table: 'crmCompanies', ...toActionScope() }}
					contactCount={actionCount}
					onSuccess={clear}
				/>
			)}

			{openModal === 'tags' && (
				<BulkAssignTagsModal
					isOpen
					onClose={close}
					scope={toActionScope('companyIds')}
					targetLabel={targetLabel}
					allTags={allTags}
					onSuccess={clear}
				/>
			)}

			{openModal === 'activity' && (
				<BulkAddActivityModal
					isOpen
					onClose={close}
					targetType="companies"
					scope={toActionScope('companyIds')}
					count={actionCount}
					targetLabel={targetLabel}
					onSuccess={clear}
				/>
			)}
		</>
	);
};

CompanyScopeActions.propTypes = {
	/** From useScopedSelection. */
	companySelection: PropTypes.shape({
		actionCount: PropTypes.number.isRequired,
		actionTarget: PropTypes.string.isRequired,
		toActionScope: PropTypes.func.isRequired,
		clear: PropTypes.func.isRequired,
	}).isRequired,
	contactSelectionCount: PropTypes.number.isRequired,
	allTags: PropTypes.array.isRequired,
};

export default CompanyScopeActions;
